import React, {PureComponent} from 'react';
import styled from "styled-components";

const TitleBarWrapper = styled.div`
    background-color: #666666;
    box-shadow: 0 0.2rem 0.8rem #aaaaaa;
    text-shadow: 0.2rem 0.2rem 0.4rem #222222;
    font-weight: bold;
    z-index: 100;
`;

const AppTitle = styled.div`
    padding: 0.25rem 1rem;
    display: inline-block;
    font-size: 1.5rem;
    color: #eeeeee;
    letter-spacing: 0.5rem;
    text-transform: uppercase;
`;

const MenuItem = styled.div`
    display: inline-block;
    font-size: 1rem;
    color: #cccccc;
    margin: 0.25rem 0.5rem;
    vertical-align: top;
    height: 1.5rem;
    cursor:pointer;
    &:hover {
        color: lightskyblue;
    }
`;

export class AppTitleBar extends PureComponent {

    render() {
        const menuItems = this.props.menu.map((item, key) => {
            const style = this.props.selected === item ? {color: "lightgreen"} : {}
            return <MenuItem
                key={"fracto_menu_" + key}
                onClick={() => this.props.callback(item)}
                style={style}>
                {item}
            </MenuItem>;
        });
        return <TitleBarWrapper>
            <AppTitle>{this.props.title}</AppTitle>
            {menuItems}
        </TitleBarWrapper>
    }
}

export default AppTitleBar;
